import React, { useState, Dispatch, SetStateAction } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { useSelector, useDispatch } from 'react-redux';
import { FormControl, Link } from '@material-ui/core';
import { handleSignin, handleForgetPassword, handleChangeUsername, handleChangePassword } from '@app/helpers';
import { ButtonSubmit, KaseyaOne, ErrorBlock, CompanyLogo, PasslyCheckbox, PasslyTextField } from '@app/components';
import { ICredentials, SetLoginForm, AuthInfo, TranslationsTypes } from '@app/models';
import { useErrorLoginObserver } from '@app/hooks';

interface IProps {
    setLoginForm: SetLoginForm;
    setAuthInfo: Dispatch<SetStateAction<AuthInfo>>;
    setRememberMe: Dispatch<SetStateAction<boolean>>;
    rememberMe: boolean;
    usernameHint: string;
    isKaseyaOneLoginEnabled?: boolean;
    handleKaseyaOneClick?: () => void;
    errorKaseyaOneCode: TranslationsTypes;
    isLoading?: boolean;
}

export const SignInUnknown: React.SFC<IProps> = ({
    setLoginForm,
    setAuthInfo,
    usernameHint,
    rememberMe,
    setRememberMe,
    isKaseyaOneLoginEnabled,
    handleKaseyaOneClick,
    errorKaseyaOneCode,
    isLoading
}) => {
    const [credentials, setCredentials] = useState<ICredentials>({ username: usernameHint, password: '' });
    const [errorCode, setErrorCode] = useState<TranslationsTypes>('');
    const [isError, setIsError] = useState<boolean>(false);
    const [emptyUsernameError, setEmptyUsernameError] = useState(false);
    const [emptyPasswordError, setEmptyPasswordError] = useState(false);

    const loggingIn = useSelector((state: any) => state.signIn.loggingIn);

    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();

    useErrorLoginObserver(setIsError, () => {}, setLoginForm, setAuthInfo, setErrorCode);

    const { username, password } = credentials;
    const handleChangeCheckbox = (checked: boolean) => setRememberMe(checked);

    return (
        <>
            <CompanyLogo />
            <form
                className='login__form-unknown'
                onSubmit={handleSignin({
                    username,
                    password,
                    rememberMe,
                    setIsError,
                    setErrorCode,
                    dispatch,
                    setEmptyUsernameError,
                    setEmptyPasswordError
                })}
            >
                <ErrorBlock className='login__error' isError={isError || !!errorKaseyaOneCode} errorCode={errorCode || errorKaseyaOneCode} />
                <FormControl fullWidth>
                    <PasslyTextField
                        autoFocus
                        label={'USERNAME'}
                        value={username}
                        onChange={handleChangeUsername(setCredentials)}
                        id='userName-input'
                        error={emptyUsernameError}
                        helperText={emptyUsernameError && translation('EMPTY_FIELD_ERROR')}
                        fullWidth
                    />
                </FormControl>
                <FormControl fullWidth>
                    <Link className='login__forgot-password' onClick={handleForgetPassword(setLoginForm)} underline='none'>{`${translation(
                        'NEED_HELP'
                    )}?`}</Link>
                    <PasslyTextField
                        label={'PASSWORD'}
                        value={password}
                        type='password'
                        onChange={handleChangePassword(setCredentials)}
                        id='userPassword-input'
                        error={emptyPasswordError}
                        helperText={emptyPasswordError && translation('EMPTY_FIELD_ERROR')}
                        fullWidth
                    />
                </FormControl>
                <PasslyCheckbox
                    className='login__checkbox'
                    name='rememberMe'
                    checked={rememberMe}
                    onChange={handleChangeCheckbox}
                    label={translation('LOGIN_CHECKBOX_LABEL')}
                />
                <div className='login__buttons'>
                    <ButtonSubmit
                        className='login__buttons-login'
                        isDisabled={loggingIn}
                        isLoad={loggingIn}
                        buttonText={translation('SIGNIN_BUTTON')}
                        id='signinUnknown'
                        disableRipple={true}
                    />
                </div>
                {isKaseyaOneLoginEnabled && <KaseyaOne onClick={handleKaseyaOneClick} isLoading={isLoading} />}
            </form>
        </>
    );
};
